import React from 'react';
import {Category, Question} from '../../types/questions';
import {useAppDispatch, useAppSelector} from '../../store/hooks';
import {set} from '../../store/features/answers/answerSlice';
import {
  Fieldset,
  RadioButton,
  styled,
  Text,
  TextTag,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import useTrans from '../../hooks/use-trans';
import PollImage from './PollImage';

const PollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.size.grid002};
  margin-bottom: ${(props) => props.theme.size.grid001};

  input[type="radio"]:focus-visible {
    outline: 2px solid #0b5cff !important;
    outline-offset: 2px !important;
  }
`;

const PollField = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

interface PollInterface {
  category: Category;
  questions: Question[];
}

const Poll: React.FC<PollInterface> = ({category, questions}) => {
  const trans = useTrans();
  const categoryTrans = trans.questions[category];
  const dispatch = useAppDispatch();
  const answers = useAppSelector((state) => state.answers);

  const selected = answers[category]?.key ?? '';

  const handleChange = (value: string) => {
    const q = questions.find((q) => q.key === value) || null;
    dispatch(set({key: category, value: q}));
  };

  return (
    <PollContainer>
      <PollImage img={categoryTrans.image} />
      <PollField>
        <Text
          tag={TextTag.h3}
          appearance={TokenTextAppearance.headline300}
          bold
        >
          {categoryTrans.title}
        </Text>
        <Fieldset aria-labelledby={categoryTrans.title}>
          {questions.map((question) => {
            return (
              <RadioButton
                key={'poll-' + question.key}
                checked={selected == question.key}
                value={question.key}
                label={categoryTrans.polls[question.key]}
                name={category}
                onChange={() => handleChange(question.key)}
              />
            );
          })}
        </Fieldset>
      </PollField>
    </PollContainer>
  );
};

export default Poll;
